<template>
  <div>

  </div>
</template>

<script>
import cookieMixin from '../../modules/cookieMixin';

export default {
  name: 'UserTrackingComponent',
  components: {},
  mixins: [cookieMixin],
  props: [
    'userId',
  ],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    checkAppsflyer: function () {
      const cookieAfUserId = this.getCookie('afUserId');
      const cookieUserAfUserId = this.getCookie('userAfUserId:' + this.userId);

      if (cookieAfUserId && (cookieAfUserId !== cookieUserAfUserId)) {
        this.setCookie('userAfUserId:' + this.userId, cookieAfUserId, 24);
        this.updateUserTrackingId('appsflyer_id-web', cookieAfUserId)
          .catch((err) => {
            console.error(err);
            this.setCookie('userAfUserId:' + this.userId, cookieAfUserId, 1);
          });
      }
    },
    updateUserTrackingId: function (type, value) {
      return axios
        .post('/ajax/user/tracking-ids', {
          name: type,
          value: value,
        });
    }
  },
  mounted() {
    this.checkAppsflyer();
  },
};
</script>
